"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var interfaces_1 = require("@hudled/interfaces");
var material_1 = require("@mui/material");
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var CheckboxInput_1 = __importDefault(require("shared/components/Form/CheckboxInput"));
var TextField_1 = __importDefault(require("shared/components/Form/TextField"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var hooks_1 = require("utils/hooks");
var other_1 = require("utils/selectors/other");
var single_1 = require("utils/selectors/single");
var WizardParts_1 = require("./WizardParts");
var TeamSetup = function () {
    var _a, _b;
    var _c = (0, react_final_form_1.useFormState)({
        subscription: { values: true, initialValues: true, pristine: true },
    }), formValues = _c.values, initialValues = _c.initialValues, pristine = _c.pristine;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var team = (0, react_redux_1.useSelector)(single_1.selectMyCompanyTeam);
    var userCanAdmin = (0, react_redux_1.useSelector)((0, other_1.makeSelectUserCan)(interfaces_1.ACCESS_LEVEL.Admin));
    var _d = __read((0, hooks_1.useSubmitter)('company_teams', team === null || team === void 0 ? void 0 : team.id), 1), teamSubmitter = _d[0];
    var _e = __read((0, hooks_1.useSubmitter)('users', profile === null || profile === void 0 ? void 0 : profile.id), 1), profileSubmitter = _e[0];
    var submit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var teamId, teamValues, userTeamRel, profileValuesToAdd, teamLeadInfo;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    teamId = team === null || team === void 0 ? void 0 : team.id;
                    if (pristine)
                        return [2 /*return*/];
                    teamValues = formValues.team, userTeamRel = formValues.userTeamRel;
                    profileValuesToAdd = {};
                    teamLeadInfo = userTeamRel.isLead ? { leadEmail: profile.email, leaderId: profile.id } : {};
                    if (!!(0, isEqual_1.default)(initialValues.team, teamValues)) return [3 /*break*/, 2];
                    return [4 /*yield*/, teamSubmitter(__assign(__assign({ companyId: profile.companyId }, teamLeadInfo), teamValues))];
                case 1:
                    (teamId = (_b.sent()).id);
                    if (profile.companyTeamId !== teamId) {
                        profileValuesToAdd.companyTeamId = teamId;
                    }
                    _b.label = 2;
                case 2:
                    if (!(0, isEqual_1.default)(initialValues.userTeamRel, userTeamRel)) {
                        profileValuesToAdd.companyTeamRels = (_a = {},
                            _a[teamId] = {
                                position: userTeamRel.position,
                                role: userTeamRel.isLead ? 'LEAD' : 'MEMBER',
                            },
                            _a);
                    }
                    if (!(Object.keys(profileValuesToAdd).length > 0)) return [3 /*break*/, 4];
                    return [4 /*yield*/, profileSubmitter(profileValuesToAdd)];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(WizardParts_1.StepTemplate, __assign({ onBeforeNext: submit, isNextDisabled: !((_a = formValues.team) === null || _a === void 0 ? void 0 : _a.name) || !((_b = formValues.userTeamRel) === null || _b === void 0 ? void 0 : _b.position) }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", flexDirection: "column", height: "100%", width: "100%" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, { children: (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: "Excellent! Now it is time to setup your team" })) }), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ pt: 2, pb: 4 }, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Think of teams as departments or functions within your organization. You can change this later." })) })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: 4, alignItems: "flex-end" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, md: 8 }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "team.name", color: "secondary", disabled: !userCanAdmin, label: "What is the name of your team?", component: TextField_1.default }) })), !userCanAdmin && ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, md: 4 }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "userTeamRel.isLead", type: "checkbox", component: CheckboxInput_1.default, label: "I\u2019m the lead" }) })))] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ my: 2 }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { component: TextField_1.default, name: "userTeamRel.position", label: "What is your role?", color: "secondary" }) }))] })) })));
};
exports.default = TeamSetup;
